import { useRouteError } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { Footer } from "./components/Footer";

function ErrorPage() {
  const error = useRouteError() as any;
  console.error(error);

  return (
    <>
      <div id="error-page">
        <div className="wrapper">
          <div className="section">
            <div className="container">
              <div className="row">
                <div className="col-md-6 ml-auto mr-auto text-center">
                  <h2 className="title text-center">Error!</h2>
                  <p>
                    <FontAwesomeIcon
                      className="center error-icon"
                      icon={faTriangleExclamation}
                      size="6x"
                    />
                  </p>
                  <hr />
                  <p>An error has occurred. Sorry for any inconvenience.</p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ErrorPage;
